import React, { createContext, useContext, useEffect, useState } from "react";
import ApiService from "services/ApiService";
import { repeatEffect, settingsConfig } from "utils/commonFunc";
import { useTranslation } from 'react-i18next';
const TrafficTotalContext = createContext(null);

export function SwItsSnstvSignalProvider({ children }) {
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get(
        "newdashboard/sgnloprt/GetSnstvSignal"
      );
      if (response.status === 200) {
        const data = response.data;

        setCurrentData({
          updateTime: data.updateTime,
          sgnlCnt: data.rows[0].sgnlCnt,
          todayCnt: data.rows[0].todayCnt,
          todayPer: data.rows[0].todayPer,
          rangeCnt: data.rows[0].rangeCnt,
          rangePer: data.rows[0].rangePer,
          diffPctCnt: data.diffPctCnt,
          diffPctPer: data.diffPctPer,
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  return (
    <TrafficTotalContext.Provider value={currentData}>
      {children}
    </TrafficTotalContext.Provider>
  );
}

// 대시보드 - 신호운영 - 감응현황 - 생략횟수 
export function SwItsSnstvSignalTotalInfo() {
  const currentData = useContext(TrafficTotalContext);
  if (!currentData) return null;

  const isIncrease = currentData.todayCnt >= currentData.rangeCnt;
  const changeValueClass = isIncrease ? "plus" : "minus";
  const isZero = parseFloat(currentData.rangeCnt) === 0;

  // 기호는 변화량이 0이 아닐 때만 
  const sign = isZero ? "" : isIncrease ? "+ " : " ";
  const date = new Date(currentData.updateTime);
  let hours = date.getHours() - 1;
    if (hours < 0) hours = 23;
    hours = String(hours).padStart(2, "0");

  return (
    <div className="flx flx_col a_center j_center">
      <div className="flx a_flx_end">
        <span className="subTxt" style={{ marginRight: "10px" }}>
          생략
        </span>
        <span className="nbr">{currentData.todayCnt?.toLocaleString()}</span>
        <span className="subTxt">회/시</span>
        <span className="subTxt sls" style={{marginRight:'10px'}}>|</span>
        <span className="nbr">{currentData.sgnlCnt}</span>
        <span className="subTxt">개소</span>
      </div>
      <div className="flx a_center j_center">
        {/* <span className="cmpr" style={{ marginRight: "10px" }}>
          전일
        </span>
        <span className={`cmpr ${changeValueClass}`} style={{ fontWeight: "var(--ft-Bold)" }} >
          {sign}
          {currentData.rangeCnt?.toLocaleString()}
        </span>
        <span className="cmpr" style={{ marginLeft: "10px" }}>
          회
        </span> */}

        <span className="cmpr" style={{ marginRight: "10px" }}>
          월 평균
        </span>
        <span className="cmpr" style={{ marginRight: "10px" }}>
          {hours}시 대비
        </span>
        <span className={`cmpr ${changeValueClass}`} style={{ fontWeight: "var(--ft-Bold)" }}>
          {sign}
          {currentData.diffPctCnt}
        </span>
        <span className="cmpr" style={{ marginLeft: "10px" }}>
          %
        </span>
      </div>
    </div>
  );
}


export function SwItsIncreaseGreenSignalTotalInfo({ showTitle = true }) {
  const currentData = useContext(TrafficTotalContext);

  if (!currentData) return null;
  
  const isIncrease = currentData.todayPer >= currentData.rangePer;
  const changeValueClass = isIncrease ? "plus" : "minus";
  
  const sign = currentData.diffPctPer > 0 ? "+" : "";
  const date = new Date(currentData.updateTime);
  let hours = date.getHours() - 1;
    if (hours < 0) hours = 23;
    hours = String(hours).padStart(2, "0");

  return (
    <div className="flx flx_col a_center j_center">
      {showTitle && (
        <p style={{ fontSize: "32px", fontWeight: "var(--ft-Light)" }}>
          녹색 시간 증가율
        </p>
      )}
      <div className="flx a_flx_end j_center">
        <span className="nbr">{currentData.todayPer.toFixed(1)}</span>&nbsp;
        <span className="subTxt" style={{ marginBottom: "14px" }}>
          %/시
        </span>
      </div>
      <div className="flx a_center j_center">
        <span className="cmpr" style={{ marginRight: "10px" }}>
          월 평균
        </span>
        <span className="cmpr" style={{ marginRight: "10px" }}>
          {hours}시 대비
        </span>
        <span className={`cmpr ${changeValueClass}`} style={{ fontWeight: "var(--ft-Bold)" }}>
          {sign}
          {currentData.diffPctPer}
        </span>
        <span className="cmpr" style={{ marginLeft: "10px" }}>
          %
        </span>
      </div>
    </div>
  );
}

export function SwItsSnstvSignalTotalCnt() {
  const currentData = useContext(TrafficTotalContext);
   const { t, i18n } = useTranslation(); 
  if (!currentData) return null;

  return (
    <>
        <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-03)'}}>{t('ActuatedSignalStatus')}
      </h2>
      {/* <span className="subTit" style={{ fontWeight: "var(--ft-Medium)" }}>
        ({currentData.sgnlCnt}개소)
      </span> */}
    </>
  );
}
